import React from 'react'
import { useTranslation } from 'react-i18next'
import { Section, InterpunctJoin } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { H6, P } from '@PipelineDeals/shared-react-components'

const DealStage = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource: deal } = useBusinessCard()

  if (!showOnlyFields.includes('stage')) return null
  if (!deal.deal_stage) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.stage')}</H6>
      <P>{deal.deal_stage.name}</P>
    </Section>
  )
}

const DealPipeline = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource: deal } = useBusinessCard()

  if (!showOnlyFields.includes('deal_pipeline_id')) return null
  if (!deal.deal_pipeline_id || !deal.deal_pipeline) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.pipeline')}</H6>
      <P>{deal.deal_pipeline.name}</P>
    </Section>
  )
}

const DealStagePipeline = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields }, resource: deal } = useBusinessCard()

  if (!showOnlyFields.includes('stage') && !showOnlyFields.includes('deal_pipeline_id')) return null

  const pipelineAndStage = (deal.deal_pipeline || deal.deal_pipeline_id) && deal.deal_stage

  return (
    <>
      {showOnlyFields.includes('stage') && showOnlyFields.includes('deal_pipeline_id') && pipelineAndStage ? (
        <Section>
          <H6>{t('businessCard.labels.stage')}</H6>
          <P><InterpunctJoin items={[deal.deal_pipeline.name, deal.deal_stage.name]} /></P>
        </Section>)
        : (
          <>
            <DealStage />
            <DealPipeline />
          </>
        )}
    </>
  )
}

export default DealStagePipeline
